import { defineComponent, computed, getCurrentInstance } from "vue";
import FileList from "@pt/views/pt-entry/creative-assets/media/file-list.vue";
import { fmtSize } from "@com/utils/data-format";
import useUploaderModule from "@pt/views/pt-entry/creative-assets/media/uploader-module";
export default defineComponent({
    components: {
        FileList: FileList
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var ref = useUploaderModule(), selectedFileList = ref.selectedFileList, fileList = ref.fileList, isUploadingStatus = ref.isUploadingStatus, uploaderSuccessFileList = ref.uploaderSuccessFileList, selectedFileSize = ref.selectedFileSize, totalSize = ref.totalSize, usedSize = ref.usedSize, isUploadEndStatus = ref.isUploadEndStatus;
        var freeSize = computed(function() {
            return store.state.assets.uploader.freeSize;
        });
        var checkAll = computed({
            get: function() {
                return selectedFileList.value.length === fileList.value.length;
            },
            set: function(val) {
                if (val) {
                    store.commit("assets/uploader/selectAllFile");
                } else {
                    store.commit("assets/uploader/clearSelectFile");
                }
            }
        });
        var isIndeterminate = computed(function() {
            return selectedFileList.value.length > 0 && selectedFileList.value.length !== fileList.value.length;
        });
        var handleCloseDialog = function() {
            store.commit("assets/uploader/setDialogVisible", false);
        };
        return {
            fileList: fileList,
            checkAll: checkAll,
            isIndeterminate: isIndeterminate,
            selectedFileList: selectedFileList,
            selectedFileSize: selectedFileSize,
            freeSize: freeSize,
            isUploadingStatus: isUploadingStatus,
            isUploadEndStatus: isUploadEndStatus,
            uploaderSuccessFileList: uploaderSuccessFileList,
            fmtSize: fmtSize,
            usedSize: usedSize,
            totalSize: totalSize,
            handleCloseDialog: handleCloseDialog
        };
    }
});
